<template>
  <main-content>
    <b-card>
      <ERegistrationHeaderFormInfo />
      <ERegistrationPublicMemberRegisterIAmSmartForm  :businessId="businessId" :iamsmartSession="iamsmartSession"/>
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationProfessionalRegisterForm from "../components/e-registration-professional-register/ERegistrationProfessionalRegisterForm";
import ERegistrationPublicMemberRegisterIAmSmartForm from "../components/e-registration-public-member-register-iamsmart/ERegistrationPublicMemberRegisterIAmSmartForm";
import ERegistrationHeaderFormInfo from "../components/e-registration-header-form/ERegistrationHeaderFormInfo";
import { IAmSmartQrCodeApi } from '@/api';

export default {
  props: ["businessId"],
  components: {
    ERegistrationHeaderFormInfo,
    ERegistrationProfessionalRegisterForm,
    ERegistrationPublicMemberRegisterIAmSmartForm
  },
  async beforeRouteEnter(to, from, next) {

      console.log("params",to.params.businessId);
      const  businessId = to.params.businessId;
      
      
      if (businessId) {
        console.log("iamsmart 1 ", businessId);
        const iamsmartSession = await IAmSmartQrCodeApi.getSession(businessId);
        console.log("iamsmart 2", iamsmartSession.data);
        next((vm) => {
          console.log("iamsmart", iamsmartSession.data);
          vm.iamsmartSession = iamsmartSession.data;
        });
      } else {
        next();
      }
    
  },
  data() {
    return {
      iamsmartSession: null
    }
  }
};
</script>

<style lang="scss" scoped></style>
